 import Vue from 'vue'

const api = () => Vue.prototype.$api

export default {
  getConsultationTypes () {
    return api().get('/consultation-types')
  },
  getProfConsultationTypes () {
    return api().get('professional/consultationTypes')
  },
  getCenterConsultationTypes () {
    return api().get('center/consultationTypes')
  }
}


// WEBPACK FOOTER //
// ./src/repositories/ConsultationTypesRepository.js